import React from 'react';
import { useHistory } from 'react-router-dom';
import logo from '../../resources/img/smileweb.png';

const Hero = () => {
  const history = useHistory();

  const handleLogin = () => {
    history.push('/login');
  };

  return (
    <section className="landing-page__hero">
      <div className="landing-page__hero-overlay"></div>
      <div className="landing-page__hero-content">
        <div className="landing-page__hero-text">
          <h1 className="landing-page__hero-title">
            SmileWEB
          </h1>
          <p className="landing-page__hero-subtitle">
            Sistema Integral de Gestión Médica y Odontológica
          </p>
          <p className="landing-page__hero-description">
            Optimiza la gestión de tu consultorio o clínica con una plataforma completa que integra historias clínicas digitales, agenda médica, facturación electrónica y mucho más.
          </p>
          <button 
            className="landing-page__hero-cta"
            onClick={handleLogin}
          >
            Iniciar Sesión
          </button>
        </div>
        <div className="landing-page__hero-image">
          <div className="landing-page__hero-logo">
            <img src={logo} alt="SmileWEB Logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
